import { render, staticRenderFns } from "./WorkflowStatesProgress.vue?vue&type=template&id=6f0bfb2e&scoped=true&"
import script from "./WorkflowStatesProgress.vue?vue&type=script&lang=js&"
export * from "./WorkflowStatesProgress.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowStatesProgress.vue?vue&type=style&index=0&id=6f0bfb2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bfb2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSpacer})
